import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const { googleSession } = useAuth();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;
    (async () => {
      if (!sessionId) return navigate("/login");
      try {
        const user = await googleSession(sessionId);
        window.history.replaceState(null, "", window.location.pathname);
        navigate(user.role === "admin" ? "/admin" : "/portal", { replace: true });
      } catch {
        navigate("/login?error=google");
      }
    })();
  }, [googleSession, navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background gap-4" data-testid="auth-callback">
      <Loader2 className="h-8 w-8 animate-spin text-primary" />
      <p className="text-muted-foreground font-medium">Signing you in…</p>
    </div>
  );
}
